
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CharcoalSketchEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(100 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.15 / (layerIndex + 1);
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const r = (5 + this.pseudoRandom(i + 2) * 50) * scale;
                
                // Smudged look
                ctx.beginPath();
                ctx.arc(rx, ry, r, 0, Math.PI * 2);
                ctx.fill();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
